import { InvoicePaymentMethodEnum } from 'src/hocs/WithSubscriptionNew/types';

export const WITH_PAYMENTS = 'WithPayments';
export const REQUEST_PAYMENTS_SUCCESS_NEW = 'app/Subscription/REQUEST_PAYMENTS_SUCCESS_NEW';
export const invoicePaymentMethod = [InvoicePaymentMethodEnum.DOM, InvoicePaymentMethodEnum.CB];
